const accept = document.getElementById("accept-cookies");
if (accept) {
	const gdpr = document.getElementById("gdpr");
	accept.addEventListener(
		"click",
		(e) => {
			console.log("CLICK");
			Cookies.set("gdpr", "1", {expires: 365, path: "/"});
			gdpr.classList.add("hide");
		},
		false
	);
}
